// @ts-ignore
import * as enUSJSON from './en-US.json';

export default {
  ...enUSJSON,
};
